import React from "react";
import "./App.css";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import AppProvider from "./components/AppProvider";
import notFound from "./assets/illustrations/404 error.svg";
import {
  Products,
  Product,
  Cart,
  Checkout,
  Home,
  Invoice,
  Eligibility,
  Dossier,
  ContactUs,
  Terms,
  Politiques,
} from "./templates";
import { BASE_URL } from "./constant";

import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

import "primereact/resources/themes/lara-light-indigo/theme.css"; //theme
import "primereact/resources/primereact.min.css"; //core css
import "primeicons/primeicons.css";

import ReactGA from "react-ga4";

// eslint-disable-next-line no-extend-native
Number.prototype.toCurrency = function () {
  return `${(this / 100)
    .toFixed(2)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")} DZ `;
};

const TRACKING_ID = "G-1XS4EFMPD0";
// ReactGA.pageview(window.location.pathname + window.location.search);

function App() {
  ReactGA.initialize(TRACKING_ID);

  return (
    <Router>
      <AppProvider>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route
            exact
            path="/products"
            render={(props) => (
              <Products
                {...props}
                brands={props.location.state ? props.location.state.brands : []}
              />
            )}
          />
          {/* <Route exact path="/products">
                        <Products />
                    </Route> */}

          <Route exact path="/eligibility">
            <Eligibility />
          </Route>
          <Route exact path="/dossier">
            <Dossier />
          </Route>
          <Route
            path="/products/:id"
            render={(props) => <Product {...props} {...props.match.params} />}
          />
          <Route
            path="/invoice/:id"
            render={(props) => <Invoice {...props} {...props.match.params} />}
          />
          <Route path="/cart" component={Cart} />
          <Route path="/terms" component={Terms} />
          <Route path="/politiques" component={Politiques} />
          <Route path="/checkout" component={Checkout} />
          <Route path="/contact" component={ContactUs} />
          <Route path="*">
            <div className="grid place-items-center text-center py-10">
              <h2 className="font-bold"></h2>
              <img
                className="w-3/5"
                src={notFound}
                onClick={() => {
                  window.location.replace(`${BASE_URL}`);
                }}
              />
            </div>
          </Route>
        </Switch>
      </AppProvider>
    </Router>
  );
}

export default App;
